import { forwardRef } from 'react';

import AppHeader from 'hb-react/shared/components/DesignSystem/AppHeader';

const BlockAppHeader = forwardRef(
  (
    {
      blockData,
      blockQuery,
      blockId,
      setBlockData,
      setBlockQuery,
      setData,
      setScreenReaderStatus,
      clearFilters,
      ...appHeaderProps
    },
    ref,
  ) => <AppHeader ref={ref} hideShadow {...appHeaderProps} />,
);

export default BlockAppHeader;
